import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    city:'',
    searchVal:'',
    areaCodeTop:VueCookies.get('areaLayer'),//SSP 联动
    userinfo:VueCookies.get('userinfo'),//用户信息 要加.user
    areaLayer:VueCookies.get('areaLayer')||'bbbbbbbb',//地区编码
    areaName:VueCookies.get('areaName'),//地区名称
    kqLayer:VueCookies.get('kqLayer'),//获取地区接口返回的请求体
    areapath:VueCookies.get('areapath'),//获取地区接口返回的请求体
    domainUri:VueCookies.get('domainUri'),
    SSOID:VueCookies.get('SSOID'),
    userName:VueCookies.get('username'),
    uuid:VueCookies.get('uuid'),
  },
  getters: {
  },
  mutations: {
    setcity(state,v) {
      state.city=v;
    },
    setareaLayer(state,v){
      state.areaLayer=v
    },
    setsearchVal(state,v){
      state.searchVal=v
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState()]  //加上这个就可以了
})
